import { Landing } from '../modules/landing/pages/Landing';
import { LandingLayout } from '../modules/landing/components/LandingLayout';
import { Login } from '../modules/auth/pages/Login';
import { Register } from '../modules/auth/pages/Register';
import { Books } from '../modules/books/pages/Books';
import { MyBooks } from '../modules/books/pages/MyBooks';
import { BookDetails } from '../modules/books/pages/BookDetails';
import { Chat } from '../modules/chat/pages/Chat';
import { createBrowserRouter } from 'react-router-dom';
import { Profile } from '../modules/profile/pages/Profile';
import { PasswordReset } from '../modules/auth/pages/PasswordReset';
import { ForgotPassword } from '../modules/auth/pages/ForgotPassword';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <LandingLayout />,
    children: [
      {
        path: '',
        element: <Landing />
      },
      {
        path: 'login',
        element: <Login />
      },
      {
        path: 'register',
        element: <Register />
      },
      {
        path: 'forgot-password',
        element: <ForgotPassword />
      },
      {
        path: 'password-reset/:uidb64/:token',
        element: <PasswordReset />
      },
      {
        path: '/chat',
        element: <Chat />
      },
      {
        path: '/chat/:dialogId',
        element: <Chat />
      },
      {
        path: '/books',
        element: <Books />
      },
      {
        path: '/books/:bookId',
        element: <BookDetails />
      },
      {
        path: '/my-books',
        element: <MyBooks />
      },
      {
        path: '/my-books/draft',
        element: <MyBooks />
      },
      {
        path: '/profile',
        element: <Profile />
      }
    ]
  }
]);
